<template>
  <v-form
    ref="form"
    lazy-validation
  >
    <v-card>
      <v-card-title v-if="title">
        <span class="text-h3">{{ $t(title) }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              v-if="authUser.isAdmin"
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.product"
                dense
                :disabled="type == 'edit'"
                :items="['oem', 'cso']"
                item-text="name"
                item-value="id"
                :label="$t('select_product_*')"
                :rules="[rules.required]"
                @change="tenantList"
              />
            </v-col>
            <v-col
              v-if="authUser.isAdmin && options.product"
              cols="6"
              sm="6"
            >
              <v-autocomplete
                v-model="options.tenant_id"
                dense
                :loading="tenantLoading"
                :items="
                  options.product
                    ? options.product == 'oem'
                      ? tenantsOEM
                      : tenantsCSO
                    : []
                "
                :disabled="type == 'edit'"
                item-text="name"
                item-value="id"
                :label="$t('select_tenant_*')"
                :rules="[rules.required]"
              />
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="options.location_id"
                dense
                :disabled="readOnly"
                :items="locationsList"
                item-value="id"
                item-text="name"
                :label="$t('select_location_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="options.charge_station_id"
                dense
                :disabled="readOnly"
                :items="chargersList"
                item-value="charge_station_id"
                item-text="charge_point_id"
                :label="$t('charge_point_id_*')"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <!--  -->
          <!-- Partners -->
          <template>
            <v-row>
              <v-col cols="12">
                <div class="d-flex align-center justify-space-between">
                  <div class="text-h5">
                    {{ $t("partners") }}
                  </div>
                  <!-- <v-btn
                     color="primary"
                     small
                     class="addButton"
                     @click="addPartners"
                   >
                     +
                   </v-btn> -->
                </div>
              </v-col>

              <v-row
                v-for="(component, index) in partners"
                :key="index"
                class="px-3 pt-1"
              >
                <v-col cols="5">
                  <div class="">
                    <v-autocomplete
                      v-model="component.dealer_partner_id"
                      dense
                      :items="partnersList"
                      item-value="id"
                      item-text="name"
                      :disabled="readOnly"
                      label="Partner"
                      :rules="[rules.required]"
                    />
                  </div>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    v-model="component.share_percentage"
                    dense
                    :disabled="readOnly"
                    :label="$t('shared_percentage_*')"
                    :rules="[rules.required, rules.float(2)]"
                  />
                </v-col>

                <v-col
                  v-if="index != 0"
                  cols=""
                  class="deleteButton"
                >
                  <div
                    class="action-btn1"
                    @click="removePartner(index)"
                  >
                    <v-icon small>
                      mdi-delete
                    </v-icon>
                  </div>
                </v-col>
              </v-row>

              <!--  -->
            </v-row>
          </template>
          <!--  -->
          <!-- Dealers -->
          <template>
            <v-row>
              <v-col cols="12">
                <div class="d-flex align-center justify-space-between">
                  <div class="text-h5">
                    {{ $t("dealers") }}
                  </div>
                  <!-- <v-btn
                     color="primary"
                     small
                     class="addButton"
                     @click="addDealers"
                   >
                     +
                   </v-btn> -->
                </div>
              </v-col>

              <v-row
                v-for="(component, index) in dealers"
                :key="index"
                class="px-3 pt-1"
              >
                <v-col cols="5">
                  <div class="">
                    <v-autocomplete
                      v-model="component.dealer_partner_id"
                      dense
                      :items="dealersList"
                      item-value="id"
                      item-text="name"
                      :disabled="readOnly"
                      label="dealer"
                      :rules="[rules.required]"
                    />
                  </div>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    v-model="component.share_percentage"
                    dense
                    :disabled="readOnly"
                    :label="$t('shared_percentage_*')"
                    :rules="[rules.required, rules.float(2)]"
                  />
                </v-col>

                <v-col
                  v-if="index != 0"
                  cols=""
                  class="deleteButton"
                >
                  <div
                    class="action-btn1"
                    @click="removeDealers(index)"
                  >
                    <v-icon small>
                      mdi-delete
                    </v-icon>
                  </div>
                </v-col>
              </v-row>

              <!--  -->
            </v-row>
          </template>
          <!--  -->
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small v-if="!readOnly">{{ $t("indicates_required_field") }}</small>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="closeForm()"
        >
          Close
        </v-btn>
        <v-btn
          v-if="!readOnly"
          color="primary"
          text
          :loading="loading"
          @click="saveItem"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";

export default {
  mixins: [validationRules],
  props: {
    type: {
      type: String,
      default() {
        return {
          time: null,
        };
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    readOnly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      options: {},
      tenantOEM: [],

      //

      partners: [
        {
          dealer_partner_id: null,
          share_percentage: null,
        },
      ],
      dealers: [
        {
          dealer_partner_id: null,
          share_percentage: null,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsList: "tenantsManagement/getTenantOptions",
      tenantsOEM: "tenantsManagement/getTenantsOEM",
      tenantsCSO: "tenantsManagement/getTenantsCSO",
      //
      locationsList: "csmsChargeStations/getLocation",
      chargersList: "csmsChargeStations/getChargers",
      //
      partnersList: "partnersAndDealers/getPartners",
      dealersList: "partnersAndDealers/getDealers",
    }),
    title() {
      if (this.readOnly) {
        return "view";
      }
      if (this.type == "create") {
        return "add_new";
      } else if (this.type == "edit") {
        return "edit";
      } else {
        return "";
      }
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (val) {
        if (val) {
          const params = { tenant_id: val };
          this.$store.dispatch("csmsChargeStations/LocationsList", params);
          this.$store.dispatch("partnersAndDealers/options", params);
        } else {
          // this.customFilters = {};
          this.$store.commit("csmsChargeStations/SET_LOCATION", []);
          // this.$store.commit("csmsChargeStations/SET_CHARGERS", []);
        }
      },
    },
    "options.location_id": {
      handler: function (v) {
        delete this.options.charge_point_id;
        if (v) {
          const params = {
            tenant_id: this.options.tenant_id,
            location_id: v,
          };
          this.$store.dispatch("csmsChargeStations/chargerList", params);
        } else {
          this.$store.commit("csmsChargeStations/SET_CHARGERS", []);
        }
      },
    },
    // Watch for changes in the item prop, ensuring price components are updated on edit
    // type: {
    //   handler() {
    //     if (this.type === "edit") {
    //       this.updatePriceComponents();
    //     }
    //   },
    //   deep: true,  // Deep watch to ensure it reacts to any changes in the item object
    // },
  },
  async mounted() {
    if (!this.authUser.isAdmin) {
      this.options.tenant_id = this.authUser.tenant_id;
      this.$store.dispatch("csmsChargeStations/LocationsList", this.options);
      this.$store.dispatch("partnersAndDealers/options", this.options);
    }

    if (this.type == "edit") {
      this.options = { ...this.item };
      const ptn = this.options.shares.find(
        (r) => r.dealer_partner_type == "partner"
      );
      const dlr = this.options.shares.find(
        (r) => r.dealer_partner_type == "dealer"
      );

      this.partners = [
        {
          dealer_partner_id: ptn?.dealer_partner_id,
          share_percentage: ptn?.share_percentage,
        },
      ];
      this.dealers = [
        {
          dealer_partner_id: dlr?.dealer_partner_id,
          share_percentage: dlr?.share_percentage,
        },
      ];
    }
  },
  methods: {
    addPartners() {
      this.partners.push({
        dealer_partner_id: null,
        share_percentage: null,
      });
    },
    removePartner(index) {
      this.partners.splice(index, 1);
    },
    addDealers() {
      this.partners.push({
        dealer_partner_id: null,
        share_percentage: null,
      });
    },
    removeDealers(index) {
      this.dealers.splice(index, 1);
    },

    tenantList() {
      if (this.product == "oem") {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "oem");
      } else {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "cso");
      }
    },
    saveItem() {
      if (this.$refs.form.validate()) {
        const params = {
          ...this.options,
          shares: [...this.partners, ...this.dealers],
        };
        this.$emit("onsave", params);
      }
    },
    closeForm() {
      // this.$refs.form.reset();
      this.$emit("onclose");
    },
  },
};
</script>
<style lang="sass" scoped>
.action-btn
    cursor: pointer
    &:hover
        i
            color: #20a390
.error-row
  background-color: #fdecea

.error-message
  color: red
  font-size: 0.9em

.all-error-text
  margin-bottom: 1.5rem !important
  display: block
  margin-left: 0.65rem

.addButton
  :deep .v-btn__content
    font-size: 1.25rem !important
.priceRow
  position: relative

.deleteButton
  .action-btn
    position: absolute
    right: 30px
    top: 1px
    background: #FDEDE8
    border-radius: 6px
    padding: 0.3em 1rem
    i
      color: #FA896B

.timeField
  :deep .v-input
    flex: 1 1 0
    min-width: 0
  :deep .v-input:first-child
    margin-right: 0.75rem

.closeTime
  margin-top: 0.7rem
  cursor: pointer
</style>
